import { render, staticRenderFns } from "./StakeholdersBlock.vue?vue&type=template&id=7f4a9a54&scoped=true"
import script from "./StakeholdersBlock.vue?vue&type=script&lang=js"
export * from "./StakeholdersBlock.vue?vue&type=script&lang=js"
import style0 from "./StakeholdersBlock.vue?vue&type=style&index=0&id=7f4a9a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4a9a54",
  null
  
)

export default component.exports